import { getProductCategories } from "@granitegroup/Services/CommonServices";
import { CustomState } from "@granitegroup/Store/Reducers";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { setGA4Event } from "@tggstore/Handlers/Utilities/CustomTracking";

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    const { qtyOrdered } = props.apiParameter;
    const cartLine = props.apiResult;
    if (cartLine.qtyOrdered !== qtyOrdered) {
        cartLine.qtyOrdered = qtyOrdered;
    }
    const state = props.getState() as CustomState;
    const session = props.getState().context.session;
    const billToCustomerName = getBillToState(state, session.billToId)?.value?.customerNumber ?? "";
    const affiliation = state.customDefaultWarehouse.warehouse?.description || "";
    const currency = session?.currency?.currencyCode || "";

    const cartlines: CartLineModel[] = [cartLine];

    const totalPrice = cartlines.reduce((acc, cartLine) => {
        const price = (cartLine.pricing?.actualPrice ?? 0) * (cartLine.qtyOrdered ?? 0);
        return acc + price;
    }, 0);

    const productIds = cartlines.map(p => p.productId).filter(id => id !== null && id !== undefined) as string[];

    const cardIndex = localStorage.getItem("card-index");
    let indexes: Array<{ id: string; attribute: string }> = [];

    if (cardIndex !== null && cardIndex !== "") {
        const item = cardIndex.split("_");
        if (item && item.length === 2) {
            indexes = [
                {
                    id: item[0],
                    attribute: item[1],
                },
            ];
        }

        // Clear after use
        localStorage.removeItem("card-index");
    }

    const page = getCurrentPage(state);

    if (page) {
        const type = page.type;
        if (type.includes("OrderDetailsPage")) {
            const elements = document.querySelectorAll('[data-test-selector^="orderLineCard"]');
            elements.forEach((el, index) => {
                const dataTestSelector = el.getAttribute("data-test-selector");
                const id = dataTestSelector?.replace("orderLineCard", ""); // Extract the ID

                const matchingItem = cartlines.find(item => item.productId === id);
                if (matchingItem) {
                    indexes.push({
                        id: matchingItem.productId!,
                        attribute: `${index}`,
                    });
                }
            });
        }
    }

    await getProductCategories({
        productIds,
        type: "product",
    }).then((data: any) => {
        const productCategories = data.result;
        setGA4Event(cartlines, "add_to_cart", {
            currency,
            affiliation,
            account_number: billToCustomerName,
            value: totalPrice,
            productCategories,
            indexes,
            a2c_method: `${page ? page.name : ""} Page`,
        });
    });
});
